import { render, staticRenderFns } from "./DocumentActionModal.vue?vue&type=template&id=6cda7e50&scoped=true&"
import script from "./DocumentActionModal.vue?vue&type=script&lang=ts&"
export * from "./DocumentActionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cda7e50",
  null
  
)

export default component.exports